import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { EventDB } from '@/enitites/event/model/types'
import IconLike from '@/shared/icons/IconLike.vue'
import IconMinusCircle from '@/shared/icons/IconMinusCircle.vue'
import IconPlusCircle from '@/shared/icons/IconPlusCircle.vue'
import { EVENT_STAR_CONFIG } from '../constants'

interface Props {
  event?: EventDB
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFeedbackBlockAdmin',
  props: {
    event: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { event: EventDB };



const isOpenRating = ref(false)

const RATING_CATEGORIES = [
  { key: 'timeliness', label: 'Timeliness', value: props.event?.totalTimeliness },
  { key: 'communication', label: 'Communication', value: props.event?.totalCommunication },
  { key: 'venue', label: 'Venue', value: props.event?.totalVenue },
  { key: 'vibe', label: 'Vibe', value: props.event?.totalVibe },
  { key: 'musicSound', label: 'Music / Sound', value: props.event?.totalMusicSound },
] as const

const displayReviewCount = computed(() => `${props.event?.countFeedbacks} reviews`)

const handleClickTopButton = () => {
  isOpenRating.value = !isOpenRating.value
}

const displayOverallRating = computed(() => `${props.event?.totalAverageRating}/5`)

return { __sfc: true,props, isOpenRating, RATING_CATEGORIES, displayReviewCount, handleClickTopButton, displayOverallRating, IconLike, IconMinusCircle, IconPlusCircle, EVENT_STAR_CONFIG }
}

})